<div class="pricing-grid" *ngIf="data?.priceDetails">
    <finder-component-header [data]="data.labels"></finder-component-header>
    <div class="pricing">
        <div class="package-name" *ngFor="let titleObj of data.titles">
            {{titleObj.title}}
        </div>
        <div class="packages">
            <div class="package" *ngFor="let package of data.priceDetails[detailSelected]?.packages">
                <div class="card">
                    <div class="card-heading">
                        <div class="title" [innerHTML]="package.title | safeHtml"></div>
                        <div class="subtitle" *ngIf="package.subtitle" [innerHTML]="package.subtitle | safeHtml"></div>
                    </div>
                    <div class="per-day">
                        <div class="price">{{package.startingPrice}}</div>
                        {{data.labels?.perDay}}
                    </div>
                    <div class="total-stay">
                        <div class="price" [attr.data-currency]="data.labels?.currency" [attr.data-or]="data.labels?.or">
                            {{package.totalPrice}}
                        </div>
                        {{data.labels?.totalStay}}
                    </div>
                </div>
            </div>
        </div>
        <div class="details">
            <div class="description">{{data?.labels.weeknight}}</div>
            <div class="dates" [innerHTML]="data.priceDetails[detailSelected]?.dates | safeHtml"></div>
        </div>
    </div>
    <div class="disclaimer">{{data.labels?.disclaimer}}</div>
</div>
